import { __ } from "@jti/fe-common";
import { replaceStringPlaceholder } from "../replaceStringPlaceholder/replaceStringPlaceholder";
export const getTimeDiff = (date) => Math.abs(new Date(date).getTime() - Date.now());
export const validateLimitedTimeBadgesData = ({ newOfferDays, timeFrom, timeTo, daysLabel, oneDayLabel, }) => {
    let limitedTimeOfferLabel;
    const daysDiffInDays = timeFrom && getTimeDiff(timeFrom) / (1000 * 3600 * 24);
    const isNewBadgeVisible = !!(newOfferDays && daysDiffInDays && daysDiffInDays <= newOfferDays);
    const timeLeftInDays = timeTo ? Math.floor(getTimeDiff(timeTo) / (1000 * 3600 * 24)) : 0;
    const isMoreThanOneDay = timeLeftInDays > 1;
    if (daysLabel && oneDayLabel) {
        const limitedTimeOfferLabelVariant = isMoreThanOneDay ? daysLabel : oneDayLabel;
        limitedTimeOfferLabel = replaceStringPlaceholder(limitedTimeOfferLabelVariant, [
            {
                placeholder: "days",
                value: timeLeftInDays,
            },
        ], false);
    }
    else {
        limitedTimeOfferLabel = isMoreThanOneDay
            ? __("prizes.days.label", [timeLeftInDays])
            : __("prizes.one.day.label", [timeLeftInDays]);
    }
    return {
        isNewBadgeVisible,
        isMoreThanOneDay,
        limitedTimeOfferLabel,
    };
};
//# sourceMappingURL=validateBadgeData.js.map